import AppUsersClient from "../clients/AppUsersClient";
import moment from 'moment';

const resource = '/SalaryManualInput';

export default {
    uploadCsv ( file ) {
        console.log( file.get( 'discriminator' ) );
        return new Promise( function ( resolve, reject ) {
            AppUsersClient.post( `${resource}/upload`, file )
                .then( response => {
                    resolve( response );
                } )
                .catch( error => {
                    console.log( error );
                    reject( error );
                } );
        } );
    },
};
